import { useEffect } from "react";
import ntactlogo from "../../assets/Ntact.png";

const PhotoPreviewScreen = ({
  submit = () => {},
  photos = {},
  setScreen = () => {},
  setCurrentStep = () => {},
  setCapturedSteps = () => {},
  reset = () => {},
  employee,
  selectedCompany,
  setPhotos = () => {}, // Added to update photos state
}) => {
const handleRetake = (poseIndex) => {
  const poseKeyMap = ["Front", "Left", "Right", "Up", "Down"];
  const poseKey = poseKeyMap[poseIndex];

  // Reset that photo
  setPhotos((prev) => ({
    ...prev,
    [poseKey]: null,
  }));

  // Remove that step from capturedSteps
  setCapturedSteps((prev) => prev.filter((step) => step !== poseKey));

  // Force FaceCaptureStep to start back at this pose
  setCurrentStep(poseIndex);

  // Go back to capture screen
  setScreen(2);
};



  const handleStartOver = () => {
    // Reset all photos and captured steps
    setPhotos({});
    setCapturedSteps([]);
    setCurrentStep(0);
    setScreen(2);
  };

  // Poses for UI
  const poses = [
    { label: "Face Forward", key: "Front" },
    { label: "Turn Left", key: "Left" },
    { label: "Turn Right", key: "Right" },
    { label: "Look Up", key: "Up" },
    { label: "Look Down", key: "Down" },
  ];

  return (
    <div className="text-center max-w-5xl mx-auto p-6 bg-white shadow rounded-xl">
      {/* Logo + Employee Info */}
      <img src={ntactlogo} alt="Logo" className="w-20 mx-auto mb-4" />
      <h2 className="font-semibold text-lg">
        {employee ? `${employee.firstname} ${employee.lastname}` : ""}
      </h2>
      <p className="text-gray-500 text-sm mb-1">
        {selectedCompany?.name} • ID: {employee?.empid}
      </p>

      {/* Instructions */}
      <h3 className="text-xl font-semibold mb-2">Review Your Photos</h3>
      <p className="text-sm text-gray-500 mb-6">
        Click Submit to complete setup once you are satisfied with the captured images.
      </p>

      {/* Photo Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
        {poses.map((pose, index) => (
          <div key={pose.label} className="border rounded p-2">
            <div className="w-full h-[140px] bg-gray-100 mb-2 flex items-center justify-center overflow-hidden rounded">
              {photos[pose.key] ? (
                <img
                  src={photos[pose.key]}
                  alt={`${pose.label} preview`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-sm text-gray-400">{pose.label} pose</span>
              )}
            </div>
            <p className="text-sm font-medium mb-1">{pose.key}</p>
            <button
              onClick={() => handleRetake(index)}
              className="text-xs px-2 py-1 border rounded hover:bg-gray-100"
            >
              Retake
            </button>
          </div>
        ))}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-center items-center flex-col gap-4">
        <button
          className="bg-black max-w-xl text-white px-8 py-3 rounded hover:bg-gray-800"
          onClick={submit}
        >
          Submit Photos
        </button>
        <button
          className="border px-4 py-1 rounded hover:bg-gray-100 text-sm"
          onClick={handleStartOver}
        >
          Start Over
        </button>
      </div>
    </div>
  );
};

export default PhotoPreviewScreen;